import { hybrid } from '@dpgradio/creative'

// Optional ?env= URL override: 'local' | 'staging' | 'production'.
// When absent, the environment falls back to build-time / app-context defaults.
function envOverride() {
  return new URLSearchParams(window.location.search).get('env')
}

export function stationIdFromUrl() {
  return new URLSearchParams(window.location.search).get('stationId')
}

export function isDev() {
  const env = envOverride()
  if (env) return env === 'local'
  return import.meta.env.DEV
}

export function isStaging() {
  const env = envOverride()
  if (env) return env === 'staging'
  const { buildName } = hybrid.appInfo()
  const queryStaging = new URLSearchParams(window.location.search).has('staging')
  return queryStaging || (buildName || '').endsWith('test') || (buildName || '').endsWith('staging')
}

const SOCKET_DOMAINS = {
  joe_fm: 'joe.be',
  joe_nl: 'joe.nl',
  qmusic_be: 'qmusic.be',
  qmusic_nl: 'qmusic.nl',
  willy: 'willy.radio',
}

export function socketHost(stationId) {
  if (isDev()) return 'http://localhost:8080/api'
  const domain = SOCKET_DOMAINS[stationId] || SOCKET_DOMAINS.qmusic_be
  const subdomain = isStaging() ? 'socket.stag' : 'socket'
  return `https://${subdomain}.${domain}/api`
}
